import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import {
  Autocomplete,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from '@mui/material'

import { useStyles } from 'src/components/un-sdg/un-sdg-list/styles'
import { ETranslationNs, ILanguageForm } from 'src/types'
import { languageCodes } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  isEditing?: boolean
}

const LanguageForm = ({ isEditing }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { errors, values, handleChange, isSubmitting, dirty, setFieldValue } =
    useFormikContext<ILanguageForm>()
  const classes = useStyles()

  const hasErrors = Object.keys(errors).length > 0

  const handleCodeChange = (event: any, newValue: { code: string }) => {
    setFieldValue('code', newValue.code)
  }

  return (
    <div className={classes.formWrapper}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>
          {isEditing ? (
            <HelperWrapper t="languages-form-title-edit" />
          ) : (
            <HelperWrapper t="languages-form-title-create" />
          )}
        </Typography>
        <div className={classes.inputsWrapper}>
          <TextField
            autoComplete="off"
            variant="standard"
            id="name"
            name="name"
            onChange={handleChange}
            type="text"
            label={t('name-input-label.v', { ns: ETranslationNs.Form }) + '*'}
            value={values.name}
            helperText={
              <Typography className={classes.warningText}>
                {errors.name && <HelperWrapper t={errors.name} />}&nbsp;
              </Typography>
            }
          />
          <Autocomplete
            value={{ code: values.code }}
            id="code"
            disablePortal
            options={languageCodes}
            getOptionLabel={(option) => option.code}
            sx={{ width: '100%' }}
            disableClearable
            onChange={handleCodeChange}
            renderInput={(params) => (
              <TextField
                {...params}
                name="code"
                id="code"
                label={t('code-input-label.v') + '*'}
                variant="standard"
                helperText={
                  <Typography className={classes.warningText}>
                    {errors.code && <HelperWrapper t={errors.code} />}&nbsp;
                  </Typography>
                }
              />
            )}
          />
          <FormControlLabel
            control={<Switch />}
            checked={values.enabled}
            label={t('enabled-checkbox-label.v')}
            name="enabled"
            onChange={handleChange}
          />
        </div>
      </div>
      <Button variant="contained" disabled={isSubmitting || !dirty || hasErrors} type="submit">
        {isEditing ? (
          <HelperWrapper t="languages-form-title-edit" />
        ) : (
          <HelperWrapper t="languages-form-title-create" />
        )}
      </Button>
    </div>
  )
}

export { LanguageForm }
